// Menu Icons
import {
  Building2,
  KeyRound,
  LayoutDashboard,
  LayoutGrid,
  SquareStack,
  Target,
  Workflow,
  Users,
  CircleUser,
  WalletCards,
  Info,
  LogOut
} from "lucide-react"
import { Link } from "react-router-dom"
import { MenuItem } from "./MenuItem"
import { Label } from "@/components/ui/label"
import { useSelector } from 'react-redux'
import { AppDispatch, RootState } from "@/redux"
import { useCookies } from "react-cookie"
import { useNavigate } from "react-router-dom"
import { Auth } from "@/API/Auth"
import { useDispatch } from "react-redux"
import { appActions } from "@/redux/slice/appSlice"
import { userActions } from "@/redux/slice/userSlice"
import { OrganizationMenu } from "./ExpandedOrganizationMenu"
import { organizationActions } from "@/redux/slice/organizationSlice"
import { workflowActions } from "@/redux/slice/workflowSlice"

export const Sidebar = () => {
  const navigate = useNavigate()
  const dispatch: AppDispatch = useDispatch()
  const [cookie, , removeCookie] = useCookies(['tcsAccessToken', 'tcsRefreshToken'])
  const { token, userData } = useSelector((state: RootState) => state.user)

  const logoutUser = async () => {
    const userToken = token ?? cookie.tcsAccessToken as string
    dispatch(appActions.setLoading(true))
    await Auth.logout(userToken)
    removeCookie('tcsAccessToken', { domain: document.location.hostname, path: '/' })
    removeCookie('tcsRefreshToken', { domain: document.location.hostname, path: '/' })
    dispatch(userActions.logoutUser())
    dispatch(organizationActions.reset())
    dispatch(workflowActions.reset())
    dispatch(appActions.setLoading(false))
    navigate('/login')
  }

  return (
    <div className="w-64 bg-darkaccent h-screen flex flex-col fixed">
      <Link to='/' className="font-bold text-2xl leading-6 my-10 px-6">
        The Camp Stack
      </Link>
      <div className="flex-1 py-6">
        {userData?.isTCSAdmin ? (
          <>
            <Label className="pl-6 flex justify-start font-semibold text-secondary mb-4">
              ADMIN TOOLS
            </Label>
            <MenuItem
              menuIcon={<LayoutGrid className="mr-2" size={20} />}
              title='Dashboard'
              goToLink='/dashboard'
            />
            <MenuItem
              menuIcon={<Target className="mr-2" size={20} />}
              title='TCS 200'
              goToLink='/tcs200'
            />
            <MenuItem
              menuIcon={<Building2 className="mr-2" size={20} />}
              title='Organizations'
              goToLink='/organizations'
            />
          </>
        ) : ''}
        <OrganizationMenu />
        {userData?.isTCSAdmin === false ||
          userData?.currentOrganization ? (
          <>
            <MenuItem
              menuIcon={<LayoutDashboard className="mr-2" size={20} />}
              title='Dashboards'
              goToLink='/dashboards'
            />
            <MenuItem
              menuIcon={<Workflow className="mr-2" size={20} />}
              title='Workflows'
              goToLink='/workflows'
            />
            <MenuItem
              menuIcon={<SquareStack className="mr-2" size={20} />}
              title='Workflow History'
              goToLink='/workflow-history'
            />
            <MenuItem
              menuIcon={<KeyRound className="mr-2" size={20} />}
              title='Credentials'
              goToLink='/credentials'
            />
            <MenuItem
              menuIcon={<Users className="mr-2" size={20} />}
              title='Users'
              goToLink='/users'
            />
          </>
        ) : null}
      </div>
      <div className="py-6">
        <MenuItem
          menuIcon={<CircleUser className="mr-2" size={20} />}
          title='My Account'
          goToLink='/my-account'
        />
        <MenuItem
          menuIcon={<WalletCards className="mr-2" size={20} />}
          title='Billing'
          goToLink='/billing'
        />
        <MenuItem
          menuIcon={<Info className="mr-2" size={20} />}
          title='Support'
          goToLink='/support'
        />
        <button
          type="button"
          className="w-full cursor-pointer flex flex-row justify-start items-center py-3 px-6 hover:bg-darkaccent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent-foreground focus-visible:ring-offset-2 focus-visible:ring-offset-darkaccent"
          onClick={logoutUser}
        >
          <LogOut className="mr-2" size={20} />
          <p className="font-medium text-base">Log Out</p>
        </button>
      </div>
    </div>
  )
}
